import { store } from "../redux/store";

export abstract class HelperService {
  static getPagesCount = (count: number): number => {
    const state = store.getState();
    const { pageSize } = state.app;

    return Math.ceil(count / pageSize);
  };
}
